import axios from "axios";
const API = {
  send: function(form) {
    return axios.post("https://api.dvas4155.com/contact", form);
  }
}
export default API;
